<button
  [type]="type"
  [disabled]="disabled"
  [class]="buttonClasses"
  [attr.title]="title || null"
  [attr.aria-label]="ariaLabel || null"
  (click)="onClick($event)">
  <ng-content></ng-content>
</button>
